// extracted by mini-css-extract-plugin
export var filterIncDec = "_gt-0";
export var leftBorder = "_gt-1";
export var rightBorder = "_gt-2";
export var stringInput = "_gt-3";